import { fetchGraphQL } from '../Connections';

import {
  getFieldListString
} from './util';

export function queryListBillingProfiles(variables, fields) {
  const query = `
    query listBillingProfiles(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $order: Order,
    ) {
      listBillingProfiles(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        order: $order,
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}


export function queryGetBillingProfile(variables, fields) {
  const query = `query getBillingProfile($billing_profile_id: String!) {
    getBillingProfile(billing_profile_id: $billing_profile_id) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryCreateBillingProfile(variables, fields) {
  const query = `mutation createBillingProfile(
    $facility_id: String!,
    $billing_profile: BillingProfileInput,
    $survey_questions: [SurveyQuestionInput],
    $fees: [FeeInput]
  ) {
    createBillingProfile(
      facility_id: $facility_id,
      billing_profile: $billing_profile,
      survey_questions: $survey_questions,
      fees: $fees
    ) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryUpdateBillingProfile(variables, fields) {
  const query = `mutation updateBillingProfile(
    $billing_profile: BillingProfileInput,
    $survey_questions: [SurveyQuestionInput],
    $fees: [FeeInput]
  ) {
    updateBillingProfile(
      billing_profile: $billing_profile,
      survey_questions: $survey_questions,
      fees: $fees
    ) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}
